export default __webpack_public_path__ + "static/media/Icon-ionic-ios-close-circle-bw.f6ee9724.svg";